import { Breadcrumb, Model, LoadingContainer } from 'peach/components'
import { getName } from 'peach/helpers'
import { useParams, useRouteMatch } from 'peach/router'

import { Page } from 'core/components'
import { useInteractionGetById } from 'core/types'

const PersonInteraction = () => {
  const { personId, interactionId } = useParams<{
    personId?: string
    interactionId?: string
  }>()
  const { url } = useRouteMatch()

  const {
    data: interaction,
    isLoading,
    error,
  } = useInteractionGetById({ personId, interactionId })

  const name = getName(interaction)

  return (
    <LoadingContainer error={error} loading={isLoading}>
      {' '}
      <Page variant='full'>
        <Breadcrumb title={name} to={url} />
        <Model.Viewer json={interaction} />
      </Page>
    </LoadingContainer>
  )
}

export default PersonInteraction
